import { Component } from '@angular/core';

/**
 * Tasksense thin shell around &lt;lib-my-profile&gt;. Tenant-side contracts
 * (USER_SELF_SERVICE, APPLICATION_CONFIG, USER_NOTIFIER) registered in
 * settings.module via NUCLEUS_USER_UI_PROVIDERS.
 */
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css',
  standalone: false,
})
export class ProfileComponent {}
